export const SET_CUPON = 'TICKET/SET_CUPON'
export const SET_CUPONS = 'TICKET/SET_CUPONS'
